// 9fbef606107a605d69c0edbcd8029e5d
import styled, { css } from 'styled-components';

const gymboreeTitleText = css`
  /* this style is for Gymboree Header Text "Spring is Every Wear" */
  .gymboree_title_text {
    color: ${(props) => props.theme.colorPalette.white};
    font-family: ${(props) => props.theme.typography.fonts.primary};
    font-weight: ${(props) => props.theme.typography.fontWeights.black};
    font-size: 32px;
    line-height: 1.05;

    @media ${(props) => props.theme.mediaQuery.large} {
      font-size: 64px;
    }
  }
`;

const gymboreeDescription = css`
  .gymboree_description {
    color: ${(props) => props.theme.colorPalette.white};
    font-family: ${(props) => props.theme.typography.fonts.primary};
    font-weight: ${(props) => props.theme.typography.fontWeights.regular};
    font-size: ${(props) => props.theme.typography.fontSizes.fs16};
    display: block;

    @media ${(props) => props.theme.mediaQuery.large} {
      font-size: ${(props) => props.theme.typography.fontSizes.fs28};
    }
  }
`;

const spacedText = css`
  /* this style is for Module N "ALL CLEARANCE" header text */
  .spaced_text {
    color: ${(props) => props.theme.colorPalette.white};
    font-family: ${(props) => props.theme.typography.fonts.primary};
    font-weight: ${(props) => props.theme.typography.fontWeights.regular};
    font-size: ${(props) =>
      props.theme.isGymboree
        ? props.theme.typography.fontSizes.fs20
        : props.theme.typography.fontSizes.fs22};
    line-height: normal;
    letter-spacing: 2px;

    @media ${(props) => props.theme.mediaQuery.large} {
      font-size: 64px;
      letter-spacing: 4px;
      font-weight: 500;
    }
  }
`;

const smallTextNormal = css`
  /* Module J Heading styles */
  .small_text_normal {
    font-family: ${(props) => props.theme.typography.fonts.primary};
    font-size: ${(props) => props.theme.typography.fontSizes.fs14};

    @media ${(props) => props.theme.mediaQuery.large} {
      font-size: ${(props) => props.theme.typography.fontSizes.fs20};
    }
  }
`;

const mediumTextBlack = css`
  .medium_text_black {
    color: ${(props) => props.theme.colorPalette.gray['900']};
    font-family: ${(props) => props.theme.typography.fonts.primary};
    font-weight: ${(props) => props.theme.typography.fontWeights.black};
    font-size: ${(props) => props.theme.typography.fontSizes.fs32};
    letter-spacing: -0.5px;
    margin-bottom: ${(props) => props.theme.spacing.ELEM_SPACING.SM};

    @media ${(props) => props.theme.mediaQuery.large} {
      font-size: ${(props) => props.theme.typography.fontSizes.fs48};
    }
  }
`;

const largeTextBlack = css`
  .large_text_black {
    color: ${(props) => props.theme.colorPalette.gray['900']};
    font-family: ${(props) => props.theme.typography.fonts.primary};
    font-weight: ${(props) => props.theme.typography.fontWeights.black};
    font-size: ${(props) => props.theme.typography.fontSizes.fs48};
    letter-spacing: -0.5px;
    line-height: 46px;
    margin-bottom: ${(props) => props.theme.spacing.ELEM_SPACING.SM};

    @media ${(props) => props.theme.mediaQuery.large} {
      font-size: ${(props) => props.theme.typography.fontSizes.fs64};
    }
  }
`;

const mediumTextWhiteBlack = css`
  /* Module H Heading styles */
  .medium_text_white_black {
    color: ${(props) => props.theme.colorPalette.white};
    font-family: ${(props) => props.theme.typography.fonts.primary};
    font-weight: ${(props) => props.theme.typography.fontWeights.black};
    font-size: ${(props) => props.theme.typography.fontSizes.fs32};

    @media ${(props) => props.theme.mediaQuery.large} {
      font-size: ${(props) => props.theme.typography.fontSizes.fs48};
    }
  }
`;

const mediumTextRegular = css`
  /* Module G Heading styles */
  .medium_text_regular {
    font-family: ${(props) => props.theme.typography.fonts.primary};
    font-size: ${(props) => props.theme.typography.fontSizes.fs32};
    font-weight: ${(props) => props.theme.typography.fontWeights.medium};
    letter-spacing: 2px;
    text-align: center;
    color: ${(props) => props.theme.colorPalette.black};
  }
`;

const smallTextWhiteMedium = css`
  /* Module S Heading styles */
  .small_text_white_medium {
    color: ${(props) => props.theme.colorPalette.white};
    font-family: ${(props) => props.theme.typography.fonts.primary};
    font-weight: ${(props) => props.theme.typography.fontWeights.semibold};
    font-size: ${(props) => props.theme.typography.fontSizes.fs20};
    letter-spacing: 2px;
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      letter-spacing: normal;
    }
    @media ${(props) => props.theme.mediaQuery.mediumOnly} {
      display: inline;
    }
    @media ${(props) => props.theme.mediaQuery.large} {
      font-size: ${(props) => props.theme.typography.fontSizes.fs32};
    }
  }
`;

const whiteLargeTextHalf = css`
  /* Module N Heading Styles Gymboree*/
  .white_large_text_half {
    font-family: ${(props) => props.theme.typography.fonts.primary};
    font-weight: ${(props) => props.theme.typography.fontWeights.regular};
    font-size: ${(props) => props.theme.typography.fontSizes.fs20};
    letter-spacing: 2px;
    color: ${(props) => props.theme.colorPalette.white};
    text-align: center;
    @media ${(props) => props.theme.mediaQuery.large} {
      font-size: ${(props) => props.theme.typography.fontSizes.fs32};
    }
  }
`;

const mediumTextSubPromo = css`
  /* Module M Heading Styles */
  .medium_text_subpromo {
    color: ${(props) => props.theme.colorPalette.gray['900']};
    font-family: ${(props) => props.theme.typography.fonts.primary};
    font-size: ${(props) =>
      props.theme.isGymboree
        ? props.theme.typography.fontSizes.fs20
        : props.theme.typography.fontSizes.fs14};
    font-weight: normal;
    text-align: center;

    @media ${(props) => props.theme.mediaQuery.large} {
      font-size: ${(props) =>
        props.theme.isGymboree
          ? props.theme.typography.fontSizes.fs32
          : props.theme.typography.fontSizes.fs20};
    }
  }
`;

const gymHomepageGymboreeDescription = css`
  /* Module A Heading Styles */
  .gym_homepage_gymboree_description {
    color: ${(props) => props.theme.colorPalette.white};
    font-family: ${(props) => props.theme.typography.fonts.primary};
    font-weight: ${(props) => props.theme.typography.fontWeights.regular};
    font-size: ${(props) => props.theme.typography.fontSizes.fs16};
    display: block;

    @media ${(props) => props.theme.mediaQuery.large} {
      font-size: ${(props) => props.theme.typography.fontSizes.fs28};
    }
  }
`;

const helpCenterHeading = css`
  /* HelpCenter Heading Styles */
  .help_center_heading {
    color: #000;
    font-family: ${(props) => props.theme.typography.fonts.secondary};
    font-weight: 600;
    font-size: 20px;
    display: block;
    padding-right: 5px;
    text-align: start;
    position: relative;
    margin-bottom: 22px;
  }
`;

const helpCenterHeadingWithBorder = css`
  /* HelpCenter Heading Styles */
  .help_center_heading_border {
    color: #000;
    font-family: ${(props) => props.theme.typography.fonts.secondary};
    font-weight: 600;
    font-size: 20px;
    display: block;
    padding-bottom: 22px;
    padding-right: 3px;
    text-align: start;
    position: relative;
    margin-bottom: 29px;
  }
  .help_center_heading_border::after {
    content: '';
    position: absolute;
    bottom: 0px;
    left: 0px;
    right: 0px;
    border-top: 1px solid #d8d8d8;
  }
`;

const helpCenterLink = css`
  /* HelpCenter Heading Styles */
  .help_center_link {
    color: #1a268a;
    font-family: ${(props) => props.theme.typography.fonts.secondary};
    font-weight: 400;
    font-size: 16px;
    display: block;
    margin-bottom: 14px;
    width: fit-content;
    text-align: start;
  }
`;
const helpCenterLinkWithBorder = css`
  /* HelpCenter Heading Styles */
  .help_center_link_border {
    color: #1a268a;
    font-family: ${(props) => props.theme.typography.fonts.secondary};
    font-weight: 400;
    font-size: 16px;
    display: block;
    margin-bottom: 50px;
    text-align: start;
  }
  .help_center_link_border::after {
    content: '';
    position: absolute;
    top: 46px;
    bottom: 0px;
    left: 0px;
    right: 0px;
    border-top: 1px solid #d8d8d8;
  }
`;

const helpCenterParagraph = css`
  /* HelpCenter Heading Styles */
  .help_center_paragraph {
    color: #494949;
    line-height: 26px;
    font-family: ${(props) => props.theme.typography.fonts.secondary};
    font-weight: 400;
    font-size: 16px;
    display: block;
    margin-bottom: 20px;
    width: fit-content;
    text-align: start;
  }
`;
const stylesMap = {
  gymboree_title_text: gymboreeTitleText,
  gymboree_description: gymboreeDescription,
  spaced_text: spacedText,
  small_text_normal: smallTextNormal,
  medium_text_black: mediumTextBlack,
  large_text_black: largeTextBlack,
  medium_text_white_black: mediumTextWhiteBlack,
  medium_text_regular: mediumTextRegular,
  small_text_white_medium: smallTextWhiteMedium,
  white_large_text_half: whiteLargeTextHalf,
  medium_text_subpromo: mediumTextSubPromo,
  gym_homepage_gymboree_description: gymHomepageGymboreeDescription,
  help_center_heading: helpCenterHeading,
  help_center_link: helpCenterLink,
  help_center_heading_border: helpCenterHeadingWithBorder,
  help_center_paragraph: helpCenterParagraph,
  help_center_link_border: helpCenterLinkWithBorder,
};

const getClassNamesArray = (headerText) => {
  let classNames = '';
  if (Array.isArray(headerText)) {
    headerText.forEach(({ textItems }) => {
      textItems.forEach(({ style }) => {
        if (style !== '' && !classNames.includes(style)) {
          classNames = `${classNames} ${style}`;
        }
      });
    });
  }

  return classNames.trim();
};

const LinkTextWrapper = styled.div`
  .link-text {
    ${(props) => (!props.promo ? `margin-bottom: ${props.theme.spacing.ELEM_SPACING.MED};` : '')}
    text-align: center;

    @media ${(props) => props.theme.mediaQuery.large} {
      ${(props) => (!props.promo ? `margin-bottom: ${props.theme.spacing.ELEM_SPACING.MED};` : '')}
    }
    ${(props) => (props.inheritedStyles ? props.inheritedStyles : '')};
  }

  ${({ headerText }) => {
    const classNameArray = getClassNamesArray(headerText).split(' ');
    return Object.keys(stylesMap).map(
      (styleRule) => classNameArray.includes(styleRule) && stylesMap[styleRule]
    );
  }}
`;

export default LinkTextWrapper;
